export const routeName = 'about-us';
export const slugs: Record<string, string> = {
	en: 'about-us',
	es: 'sobre-nosotros',
	ca: 'sobre-nosaltres',
	it: 'chi-siamo',
};
export const sitemap = { changefreq: 'monthly', priority: '0.8', lastmod: '2025-01-01' };
